import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export const CountDown = ({ endTime, preText }: {endTime: any, preText?: any}) => {
  const [tickInterval, setTickInterval] = useState(-1);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    setTickInterval(
      setInterval(() => {
        setTick((prevTick) => prevTick + 1);
      }, 1000) as unknown as number
    );
    return () => {
      clearInterval(tickInterval);
    };
  }, []);

  tick;
  const duration = dayjs.duration(endTime.diff(dayjs().tz('America/Chicago'))); //Compare end time to local time in Chicago time.
  let seconds: number | string = duration.seconds();
  if(seconds < 10) {
    seconds = `0${seconds}`;
  }
  let minutes: number | string = duration.minutes();
  if(minutes < 10) {
    minutes = `0${minutes}`;
  }
  let hours: number | string = duration.hours();
  if(hours < 10) {
    hours = `0${hours}`;
  }
  const months: number | string = duration.months();
  if(duration.asSeconds() <= 0) {
    return null;
  }

  return (
    <>
      {preText || ''}
      {months > 0 && `${months} Month${months === 1 ? '' : 's'}, `}
      {duration.days() > 0 && duration.days() + ` Day${duration.days() === 1 ? '' : 's'}, `}
      <span className='w-[72px]'>{ hours + ':' + minutes + ':' + seconds}</span>
    </>
  );
};
